import type { DataSourcePropFilterValue } from "@infinite-table/infinite-react";
import type { FilterParams, PaginationParams } from "epsm-api-types";
import type { NewsRaw } from "epsm-api-types/models";

export enum SentimentString {
	Neutral = "Neutral",
	Positive = "Positive",
	Negative = "Negative",
	NoData = "",
}

export enum NEWS_COLUMNS {
	SENTIMENT = "sentiment",
	SIGNIFICANCY = "significancy",
	DATASET = "dataset",
	TICKER = "ticker",
	TITLE = "title",
	SECTOR = "sector",
	CATEGORY = "category",
	PUBLICATION_DATE = "publication_date",
}

export enum NEWS_DATASET {
	BRIEF = "symbol_briefs",
	NEWS = "news",
	EVENTS = "events",
	AI_ANALYSIS = "ai-analysis",
}

export enum TICKER_FILTER {
	ALL = "all",
	TOP = "top",
	OTHER = "other",
}

export enum NEWS_CATEGORY {
	INVESTOR_SENTIMENT = "investor sentiment",
	LEGAL = "legal",
	EXECUTIVE = "executive",
	FINANCIALS = "financials",
	DIVIDEND = "dividend",
	EXCEPTIONAL_INCIDENT = "exceptional incident",
	TRANSCRIPTS = "transcripts",
	INSIDER_TRADING = "insider trading",
	MERGERS_AND_ACQUISITIONS = "mergers and acquisitions",
	GENERAL_NEWS = "general news",
	PARTNERSHIPS = "partnerships",
	PRODUCT_UPDATE = "product update",
	EARNINGS = "earnings",
	ANALYST_REVIEW = "analyst review",
	MANAGEMENT = "management",
	PERSONNEL = "personnel",
	TRADING = "trading",
	OTHER = "other",
}

export enum NEWS_SECTOR {
	BASIC_MATERIALS = "Basic Materials",
	COMMUNICATION_SERVICES = "Communication Services",
	CONSUMER_CYCLICAL = "Consumer Cyclical",
	CONSUMER_DEFENSIVE = "Consumer Defensive",
	ENERGY = "Energy",
	FINANCIAL = "Financial",
	FINANCIAL_SERVICES = "Financial Services",
	HEALTHCARE = "Healthcare",
	INDUSTRIAL = "Industrial",
	INDUSTRIALS = "Industrials",
	REAL_ESTATE = "Real Estate",
	TECHNOLOGY = "Technology",
	UTILITIES = "Utilities",
}

export interface IBrief {
	brief?: string;
	ticker?: string;
}

export enum LOCAL_FIELDS {
	COMPANY_TICKER = "company.ticker",
	SECURITY_RAW = "securityRaw",
}

export interface NewsState {
	ticker?: string;
	tickerFilter?: TICKER_FILTER;
	columnOrder?: string[];
	filter?: FilterParams;
	datasetFilters?: NEWS_DATASET[];
	categoryFilters?: NEWS_CATEGORY[];
	sectorFilters?: NEWS_SECTOR[];
	filterValue?: DataSourcePropFilterValue<NewsRaw>;
	pagination?: PaginationParams;
	color?: string;
}
